<mode-labeled-menu
  label="Repeats every"
  [selected]="selected"
  [menuItems]="options"
  (menuChange)="onCadenceChange($event)"
  name="frequency"
  data-test="frequency-selector"
></mode-labeled-menu>
